import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import type { AdCodeVariableGroup } from '../lib/adCodeVariables'

interface VariableReferenceProps {
  groups: AdCodeVariableGroup[]
  /** Expand every group by default. */
  defaultOpen?: boolean
}

/** Collapsible reference listing the variables/placeholders usable in ad code. */
export function VariableReference({ groups, defaultOpen = false }: VariableReferenceProps) {
  return (
    <Accordion
      type="multiple"
      className="w-full"
      defaultValue={defaultOpen ? groups.map((_, gi) => `group-${gi}`) : undefined}
    >
      {groups.map((group, gi) => (
        <AccordionItem
          key={group.label}
          value={`group-${gi}`}
          className="border-b border-(--ad-border) last:border-0 px-4"
        >
          <AccordionTrigger className="text-sm font-medium py-3">{group.label}</AccordionTrigger>
          <AccordionContent>
            <div className="pb-3 space-y-1">
              {group.vars.map((v) => (
                <div
                  key={v.name}
                  className={`py-2 text-sm border-b border-(--ad-border) last:border-0 ${v.example ? 'flex flex-col gap-2' : 'grid grid-cols-[minmax(280px,auto)_1fr] gap-3'}`}
                >
                  <div className={v.example ? 'flex items-start gap-3' : 'contents'}>
                    <code className="font-mono text-xs bg-(--ad-neutral-soft) text-(--ad-text) px-1.5 py-0.5 rounded self-start whitespace-nowrap">
                      {group.syntax === 'literal'
                        ? v.name
                        : v.example
                          ? `#${v.name}`
                          : `{{${v.name}}}`}
                    </code>
                    <span className="text-(--ad-text-muted) text-xs leading-relaxed">
                      {v.description}
                    </span>
                  </div>
                  {v.example && (
                    <pre className="font-mono text-xs bg-(--ad-neutral-soft) text-(--ad-text) px-3 py-2 rounded overflow-x-auto leading-relaxed">
                      {v.example}
                    </pre>
                  )}
                </div>
              ))}
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  )
}
